/** SP5 §3 — promote attachment/coupon/check field values to transaction.<name>.
 *  First matching document by order wins; anything missing → null. Pure. */
export function materializeTransactionFields(promotions, documents) {
    const out = {};
    for (const p of promotions ?? []) {
        const doc = documents.find((d) => d.classificationKey === p.promoteFrom.classificationKey);
        out[p.name] = doc ? (doc.fields[p.promoteFrom.field] ?? null) : null;
    }
    return out;
}
//# sourceMappingURL=transaction-fields.js.map